import { Icon } from '@design/components/icon/Icon';
import { Tooltip } from '@design/components/tooltip/Tooltip';
import clsx from 'clsx';
import { Link, To } from 'react-router';

import styles from './SectionTitle.module.scss';

export interface SectionTitleProps {
  title: string;
  linkTo?: To;
  tooltip?: string;
  variant?: 'default' | 'small';
}

export const SectionTitle = ({
  title,
  linkTo,
  tooltip,
  variant = 'default',
  ...rest
}: SectionTitleProps) => {
  const titleElement = (
    <Tooltip
      isTouchDevice={false}
      label={tooltip}
      disabled={!tooltip}
      strategy="fixed"
      {...rest}
    >
      <div className={styles.titleWrapper} data-section-title-wrapper>
        <p
          className={clsx(styles.title, {
            [styles.small]: variant === 'small',
            [styles.withTextDecoration]: !!tooltip,
          })}
          data-section-title
        >
          {title}
        </p>
        {linkTo && <Icon iconName="ChevronBoldRight" size={12} />}
      </div>
    </Tooltip>
  );

  return linkTo ? (
    <Link className={styles.styledLink} to={linkTo}>
      {titleElement}
    </Link>
  ) : (
    titleElement
  );
};
